import {routes_modules} from './routes';
import useMyRoutes from '../../../hooks/useMyRoutes';
const Auth=()=>{
  return useMyRoutes(routes_modules);
}
export default Auth
